export const camelToSnakeCase = (string: string) =>
  string.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
export const snakeToCamelCase = (string: string) =>
  string.replace(/_([a-z])/g, (g) => g[1]?.toUpperCase() ?? "");

export const camelToSnakeCaseObject = (obj: any): any => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(camelToSnakeCaseObject);
  }

  const snakeObj: any = {};
  Object.keys(obj).forEach((key) => {
    const snakeKey = camelToSnakeCase(key);
    snakeObj[snakeKey] = camelToSnakeCaseObject(obj[key]);
  });

  return snakeObj;
};

export const snakeToCamelCaseObject = (obj: any): any => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(snakeToCamelCaseObject);
  }

  const camelObj: any = {};
  Object.keys(obj).forEach((key) => {
    const camelKey = snakeToCamelCase(key);
    camelObj[camelKey] = snakeToCamelCaseObject(obj[key]);
  });

  return camelObj;
};

export const stringToKey = (string: string) => {
  // Convert the string to lowercase
  let processedString = string.toLowerCase();

  // Normalize the string to decomposed form (NFD)
  const normalizedString = processedString.normalize("NFD");

  // Use a regular expression to match non-ASCII characters
  // eslint-disable-next-line no-control-regex
  const nonEnglishRegex = /[^\x00-\x7F]/g;

  // Replace non-English characters with their closest English equivalents
  const replacedString = normalizedString.replace(nonEnglishRegex, (char) => {
    // Check if the character has an ASCII representation
    const asciiChar = char.normalize("NFKD").replace(/[\u0300-\u036F]/g, "");

    // If the ASCII representation exists, use it; otherwise, remove the character
    return /[a-zA-Z0-9]/.test(asciiChar) ? asciiChar : "";
  });

  // Remove non-English characters using a regular expression
  processedString = replacedString.replace(nonEnglishRegex, "");

  // Replace spaces with underscores
  processedString = processedString.replace(/ /g, "_");

  return processedString;
};

export const camelCaseToTitleCase = (input: string): string => {
  // Split the string into words by looking for points where a lowercase letter is followed by an uppercase letter
  const words = input.split(/(?=[A-Z])/);

  // Capitalize the first letter of each word and join them back with spaces
  const titleCased = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return titleCased;
};
